<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="Multifuncţional laser MB2236">
     Multifuncţional laser MB2236
    </a>
   </p>
   <p class="toc-1-style">
    <a href="safety.html#safety_ro" title="Informaţii de siguranţă">
     Informaţii de siguranţă
    </a>
   </p>
   <div id="divd0e18">
    <p class="toc-2-style">
     <a href=".html#d0e23" title="Convenţii">
      Convenţii
     </a>
    </p>
    <p class="toc-2-style">
     <a href="safety-cable-topic.html#d0e42" title="Declaraţii produs">
      Declaraţii produs
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="learning-about-printer-chapter.html#learning-about-printer-chapter_ro" title="Aflaţi despre imprimantă">
     Aflaţi despre imprimantă
    </a>
   </p>
   <div id="divd0e172">
    <p class="toc-2-style">
     <a href="finding-information-about-printer-topic.html#finding-information-about-printer_ro" title="Găsirea informaţiilor despre imprimantă">
      Găsirea informaţiilor despre imprimantă
     </a>
    </p>
    <p class="toc-2-style">
     <a href="finding-printer-serial-number-topic.html#finding-printer-serial-number_ro" title="Găsirea numărului de serie al imprimantei">
      Găsirea numărului de serie al imprimantei
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configured-model-topic.html#configured-model_ro" title="Configuraţie imprimantă">
      Configuraţie imprimantă
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-control-panel-group.html#d0e379" title="Utilizarea panoului de control">
      Utilizarea panoului de control
     </a>
    </p>
    <p class="toc-2-style">
     <a href="customizing-home-screen-topic.html#customizing-home-screen_ro" title="Particularizarea ecranului de &icirc;nceput">
      Particularizarea ecranului de &icirc;nceput
     </a>
    </p>
    <p class="toc-2-style">
     <a href="changing-language-of-onscreen-keyboard-topic.html#changing-language-of-onscreen-keyboard_ro" title="Schimbarea limbii tastaturii de pe ecran">
      Schimbarea limbii tastaturii de pe ecran
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-status-of-power-button-and-indicator-light-topic.html#understanding-status-of-power-button-and-indicator-light_ro" title="&Icirc;nţelegerea stării butonului de alimentare şi a indicatorului luminos">
      &Icirc;nţelegerea stării butonului de alimentare şi a indicatorului luminos
     </a>
    </p>
    <p class="toc-2-style">
     <a href="selecting-paper-group.html#d0e759" title="Selectarea h&acirc;rtiei">
      Selectarea h&acirc;rtiei
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setting-up-using-home-screen-apps-chapter.html#setting-up-using-home-screen-apps-chapter_ro" title="Configurarea şi instalarea">
     Configurarea şi instalarea
    </a>
   </p>
   <div id="divd0e1623">
    <p class="toc-2-style">
     <a href="selecting-location-printer-m-topic.html#selecting-location-printer-m_ro" title="Alegerea unui loc pentru imprimantă">
      Alegerea unui loc pentru imprimantă
     </a>
    </p>
    <p class="toc-2-style">
     <a href="attaching-cables-topic.html#attaching-cables_ro" title="Ataşarea cablurilor">
      Ataşarea cablurilor
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-printer-to-fax-group.html#d0e1818" title="Configurarea imprimantei pentru fax">
      Configurarea imprimantei pentru fax
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-smtp-server-for-e-mail-topic.html#configuring-smtp-server-for-e-mail_ro" title="Configurarea setărilor de e-mail SMTP">
      Configurarea setărilor de e-mail SMTP
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-paper-and-specialty-media-group.html#d0e3751" title="&Icirc;ncărcarea h&acirc;rtiei şi a suporturilor speciale">
      &Icirc;ncărcarea h&acirc;rtiei şi a suporturilor speciale
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-printer-software-topic.html#d0e3884" title="Instalarea şi actualizarea software-ului, a driverelor şi a firmware-ului">
      Instalarea şi actualizarea software-ului, a driverelor şi a firmware-ului
     </a>
    </p>
    <p class="toc-2-style">
     <a href="connecting-printer-to-wireless-network-topic.html#d0e4116" title="Lucrul &icirc;n reţea">
      Lucrul &icirc;n reţea
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-cloud-connector-profile-topic.html#creating-cloud-connector-profile_ro" title="Crearea unui profil Cloud Connector">
      Crearea unui profil Cloud Connector
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-menu-settings-page-h1-topic.html#printing-menu-settings-page-h1_ro" title="Imprimarea paginii de setări meniuri">
      Imprimarea paginii de setări meniuri
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="securing-the-printer.html#securing-the-printer_ro" title="Securizarea imprimantei">
     Securizarea imprimantei
    </a>
   </p>
   <div id="divd0e4634">
    <p class="toc-2-style">
     <a href="erasing-printer-memory-topic.html#erasing-printer-memory_ro" title="Ştergerea memoriei imprimantei">
      Ştergerea memoriei imprimantei
     </a>
    </p>
    <p class="toc-2-style">
     <a href="restoring-factory-default-settings-topic.html#restoring-factory-default-settings_ro" title="Revenirea la setările prestabilite din fabrică">
      Revenirea la setările prestabilite din fabrică
     </a>
    </p>
    <p class="toc-2-style">
     <a href="statement-of-volatility-topic.html#statement-of-volatility_ro" title="Declaraţie privind volatilitatea">
      Declaraţie privind volatilitatea
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="printing-chapter.html#printing-chapter_ro" title="Imprimarea">
     Imprimarea
    </a>
   </p>
   <div id="divd0e4756">
    <p class="toc-2-style">
     <a href="printing-from-computer-h2-topic.html#printing-from-computer-h2_ro" title="Imprimarea de pe un computer">
      Imprimarea de pe un computer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-mobile-device-using-lexmark-print-topic.html#d0e4782" title="Imprimarea de pe un dispozitiv mobil">
      Imprimarea de pe un dispozitiv mobil
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-flash-drive-topic.html#printing-from-flash-drive_ro" title="Imprimarea de pe o unitate flash">
      Imprimarea de pe o unitate flash
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-flash-drives-and-file-types-topic.html#supported-flash-drives-and-file-types_ro" title="Unităţi flash şi tipuri de fişiere acceptate">
      Unităţi flash şi tipuri de fişiere acceptate
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-confidential-jobs-topic.html#configuring-confidential-jobs_ro" title="Configurarea lucrărilor de imprimare confidenţiale">
      Configurarea lucrărilor de imprimare confidenţiale
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-confidential-and-other-held-jobs-topic.html#printing-confidential-and-other-held-jobs_ro" title="Imprimarea lucrărilor confidenţiale şi a altor lucrări &icirc;n aşteptare">
      Imprimarea lucrărilor confidenţiale şi a altor lucrări &icirc;n aşteptare
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-cloud-connector-profile-topic.html#printing-from-cloud-connector-profile_ro" title="Imprimarea dintr-un profil Cloud Connector">
      Imprimarea dintr-un profil Cloud Connector
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-font-sample-list-topic.html#printing-font-sample-lis_ro" title="Imprimarea unei liste de eşantioane de fonturi">
      Imprimarea unei liste de eşantioane de fonturi
     </a>
    </p>
    <p class="toc-2-style">
     <a href="placing-separator-sheets-topic.html#placing-separator-sheets_ro" title="Inserarea colilor de separare &icirc;ntre copii">
      Inserarea colilor de separare &icirc;ntre copii
     </a>
    </p>
    <p class="toc-2-style">
     <a href="canceling-print-job-topic.html#canceling-print-job_ro" title="Anularea unei lucrări de imprimare">
      Anularea unei lucrări de imprimare
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-toner-darkness-topic.html#adjusting-toner-darkness_ro" title="Reglarea luminozităţii tonerului">
      Reglarea luminozităţii tonerului
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="copying.html#copying_ro" title="Copierea">
     Copierea
    </a>
   </p>
   <div id="divd0e5378">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-copy-topic.html#using-ADF-and-scanner-glass-copy_ro" title="Utilizarea alimentatorului automat de documente și a geamului scanerului">
      Utilizarea alimentatorului automat de documente și a geamului scanerului
     </a>
    </p>
    <p class="toc-2-style">
     <a href="making-copies-topic.html#making-copies_ro" title="Realizarea de copii">
      Realizarea de copii
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-photos-topic.html#copying-photos_ro" title="Copierea fotografiilor">
      Copierea fotografiilor
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-letterhead-topic.html#copying-letterhead_ro" title="Copierea pe h&acirc;rtie cu antet">
      Copierea pe h&acirc;rtie cu antet
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-on-both-sides-of-paper-topic.html#copying-on-both-sides-of-paper_ro" title="Copierea pe ambele feţe ale h&acirc;rtiei">
      Copierea pe ambele feţe ale h&acirc;rtiei
     </a>
    </p>
    <p class="toc-2-style">
     <a href="reducing-enlarging-copies-topic.html#reducing-enlarging-copies_ro" title="Micşorarea sau mărirea copiilor">
      Micşorarea sau mărirea copiilor
     </a>
    </p>
    <p class="toc-2-style">
     <a href="saving-paper-topic.html#saving-paper_ro" title="Copierea mai multor pagini pe o singură foaie">
      Copierea mai multor pagini pe o singură foaie
     </a>
    </p>
    <p class="toc-2-style">
     <a href="collating-copies-topic.html#collating-copies_ro" title="Asamblarea copiilor">
      Asamblarea copiilor
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-cards-topic.html#copying-cards_ro" title="Copierea cărţilor de identitate">
      Copierea cărţilor de identitate
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-copy-shortcut-topic.html#creating-copy-shortcut_ro" title="Crearea unei comenzi rapide pentru copiere">
      Crearea unei comenzi rapide pentru copiere
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="e-mailing-chapter.html#e-mailing-chapter_ro" title="E-mailul">
     E-mailul
    </a>
   </p>
   <div id="divd0e5708">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-email-topic.html#using-ADF-and-scanner-glass-email_ro" title="Utilizarea alimentatorului automat de documente și a geamului scanerului">
      Utilizarea alimentatorului automat de documente și a geamului scanerului
     </a>
    </p>
    <p class="toc-2-style">
     <a href="sending-email-topic.html#sending-email_ro" title="Trimiterea unui e-mail">
      Trimiterea unui e-mail
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="Faxing.html#Faxing_ro" title="Faxul">
     Faxul
    </a>
   </p>
   <div id="divd0e5823">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-fax-topic.html#using-ADF-and-scanner-glass-fax_ro" title="Utilizarea alimentatorului automat de documente și a geamului scanerului">
      Utilizarea alimentatorului automat de documente și a geamului scanerului
     </a>
    </p>
    <p class="toc-2-style">
     <a href="sending-fax-topic.html#sending-fax_ro" title="Trimiterea unui fax">
      Trimiterea unui fax
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scheduling-fax-topic.html#sending-fax-scheduled-time_ro" title="Programarea unui fax">
      Programarea unui fax
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-fax-destination-shortcut-topic.html#creating-fax-destination-shortcut_ro" title="Crearea unei comenzi rapide pentru o destinaţie de fax">
      Crearea unei comenzi rapide pentru o destinaţie de fax
     </a>
    </p>
    <p class="toc-2-style">
     <a href="changing-fax-resolution-topic.html#changing-fax-resolution_ro" title="Schimbarea rezoluţiei faxului">
      Schimbarea rezoluţiei faxului
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-fax-darkness-topic.html#adjusting-fax-darkness_ro" title="Ajustarea &icirc;ntunecimii faxului">
      Ajustarea &icirc;ntunecimii faxului
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-fax-log-topic.html#printing-fax-log_ro" title="Imprimarea unui jurnal de fax">
      Imprimarea unui jurnal de fax
     </a>
    </p>
    <p class="toc-2-style">
     <a href="blocking-junk-faxes-topic.html#blocking-junk-faxes_ro" title="Blocarea faxurilor nesolicitate">
      Blocarea faxurilor nesolicitate
     </a>
    </p>
    <p class="toc-2-style">
     <a href="holding-faxes-topic.html#holding-faxes_ro" title="Păstrarea faxurilor">
      Păstrarea faxurilor
     </a>
    </p>
    <p class="toc-2-style">
     <a href="forwarding-fax-topic.html#forwarding-fax_ro" title="Redirecţionarea unui fax">
      Redirecţionarea unui fax
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="FTP.html#FTP_ro" title="Scanarea">
     Scanarea
    </a>
   </p>
   <div id="divd0e6217">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-scan-topic.html#using-ADF-and-scanner-glass-scan_ro" title="Utilizarea alimentatorului automat de documente și a geamului scanerului">
      Utilizarea alimentatorului automat de documente și a geamului scanerului
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-to-computer-topic.html#scanning-to-computer_ro" title="Scanarea către un computer">
      Scanarea către un computer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-to-flash-drive-topic.html#scanning-to-flash-drive_ro" title="Scanarea către o unitate flash">
      Scanarea către o unitate flash
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-to-ftp-server-using-shortcut-topic.html#scanning-to-ftp-server-using-shortcut_ro" title="Scanarea pe un server FTP">
      Scanarea pe un server FTP
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-network-folder-using-shortcut-topic.html#scanning-network-folder-using-shortcut_ro" title="Scanare cu trimitere &icirc;ntr-un folder din reţea">
      Scanare cu trimitere &icirc;ntr-un folder din reţea
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-to-cloud-connector-profile-topic.html#scanning-to-cloud-connector-profile_ro" title="Scanarea &icirc;ntr-un profil Cloud Connector">
      Scanarea &icirc;ntr-un profil Cloud Connector
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="understanding-printer-menus-chapter.html#understanding-printer-menus-chapter_ro" title="Utilizarea meniurilor imprimantei">
     Utilizarea meniurilor imprimantei
    </a>
   </p>
   <div id="divd0e6564">
    <p class="toc-2-style">
     <a href="menu-map-mfp-topic.html#menus-map-mfp_ro" title="Hartă meniuri">
      Hartă meniuri
     </a>
    </p>
    <p class="toc-2-style">
     <a href="preferences-topic.html#d0e6912" title="Dispozitiv">
      Dispozitiv
     </a>
    </p>
    <p class="toc-2-style">
     <a href="layout-topic.html#d0e8548" title="Imprimare">
      Imprimare
     </a>
    </p>
    <p class="toc-2-style">
     <a href="tray-configuration-topic.html#d0e9341" title="H&acirc;rtie">
      H&acirc;rtie
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copy-defaults-topic.html#d0e9642" title="Copiere">
      Copiere
     </a>
    </p>
    <p class="toc-2-style">
     <a href="fax-defaults-subgroup.html#d0e9864" title="Fax">
      Fax
     </a>
    </p>
    <p class="toc-2-style">
     <a href="email-setup-topic.html#d0e11486" title="E-mail">
      E-mail
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ftp-defaults-topic.html#d0e12169" title="FTP">
      FTP
     </a>
    </p>
    <p class="toc-2-style">
     <a href="flash-drive-scan-topic.html#d0e12601" title="Unitate USB">
      Unitate USB
     </a>
    </p>
    <p class="toc-2-style">
     <a href="network-overview-topic.html#d0e13206" title="Reţea/Porturi">
      Reţea/Porturi
     </a>
    </p>
    <p class="toc-2-style">
     <a href="login-methods-subgroup.html#d0e15221" title="Securitate">
      Securitate
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cloud-connector-menu-topic.html#cloud-connector-menu_ro" title="Cloud Connector">
      Cloud Connector
     </a>
    </p>
    <p class="toc-2-style">
     <a href="menu-settings-page-topic.html#d0e15935" title="Rapoarte">
      Rapoarte
     </a>
    </p>
    <p class="toc-2-style">
     <a href="troubleshooting-menu-topic.html#troubleshooting-menu_ro" title="Rezolvarea problemelor">
      Rezolvarea problemelor
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintain-printer-chapter.html#maintain-printer-chapter_ro" title="&Icirc;ntreţinerea imprimantei">
     &Icirc;ntreţinerea imprimantei
    </a>
   </p>
   <div id="divd0e16227">
    <p class="toc-2-style">
     <a href="checking-status-of-parts-and-supplies-topic.html#checking-status-of-parts-and-supplies_ro" title="Verificarea stării pieselor şi consumabilelor">
      Verificarea stării pieselor şi consumabilelor
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-supply-notifications-topic.html#configuring-supply-notifications_ro" title="Configurarea notificărilor de aprovizionare">
      Configurarea notificărilor de aprovizionare
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-e-mail-alert-topic.html#setting-up-e-mail-alert_ro" title="Setarea avertizărilor prin e-mail">
      Setarea avertizărilor prin e-mail
     </a>
    </p>
    <p class="toc-2-style">
     <a href="viewing-reports-topic.html#viewing-reports_ro" title="Vizualizarea rapoartelor">
      Vizualizarea rapoartelor
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ordering-supplies-group.html#ordering-supplies-group_ro" title="Comandarea pieselor şi consumabilelor">
      Comandarea pieselor şi consumabilelor
     </a>
    </p>
    <p class="toc-2-style">
     <a href="replacing-toner-cartridge-topic.html#d0e16498" title="&Icirc;nlocuirea pieselor şi consumabilelor">
      &Icirc;nlocuirea pieselor şi consumabilelor
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cleaning-printer-topic.html#d0e16643" title="Curăţarea componentelor imprimantei">
      Curăţarea componentelor imprimantei
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-power-save-mode-settings-topic.html#d0e16731" title="Economisirea de energie şi h&acirc;rtie">
      Economisirea de energie şi h&acirc;rtie
     </a>
    </p>
    <p class="toc-2-style">
     <a href="moving-printer-topic.html#moving-printer_ro" title="Mutarea imprimantei &icirc;n altă locaţie">
      Mutarea imprimantei &icirc;n altă locaţie
     </a>
    </p>
    <p class="toc-2-style">
     <a href="shipping-printer-topic.html#shipping-printer_ro" title="Expedierea imprimantei">
      Expedierea imprimantei
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshooting-chapter.html#troubleshooting-chapter_ro" title="Depanarea unei probleme">
     Depanarea unei probleme
    </a>
   </p>
   <div id="divd0e16892">
    <p class="toc-2-style">
     <a href="print-quality-problems-topic.html#print-quality-problems_ro" title="Probleme legate de calitatea imprimării">
      Probleme legate de calitatea imprimării
     </a>
    </p>
    <p class="toc-2-style">
     <a href="print-quality-is-poor-subgroup.html#d0e17003" title="Probleme de imprimare">
      Probleme de imprimare
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-printer-not-responding-topic.html#trb-printer-not-responding_ro" title="Imprimanta nu răspunde">
      Imprimanta nu răspunde
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-unable-to-read-flash-drive-topic.html#trb-unable-to-read-flash-drive_ro" title="Nu se poate citi unitatea flash">
      Nu se poate citi unitatea flash
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-usb-port-topic.html#enabling-usb-port_ro" title="Activarea portului USB">
      Activarea portului USB
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-open-embedded-web-server-topic.html#d0e19610" title="Probleme de conectare la reţea">
      Probleme de conectare la reţea
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-replace-cartridge-printer-region-mismatch-topic.html#d0e19828" title="Probleme cu consumabilele">
      Probleme cu consumabilele
     </a>
    </p>
    <p class="toc-2-style">
     <a href="clearing-jams.html#clearing-jams_ro" title="&Icirc;ndepărtarea blocajelor">
      &Icirc;ndepărtarea blocajelor
     </a>
    </p>
    <p class="toc-2-style">
     <a href="solving-printer-problems.html#solving-printer-problems_ro" title="Probleme cu alimentarea de h&acirc;rtie">
      Probleme cu alimentarea de h&acirc;rtie
     </a>
    </p>
    <p class="toc-2-style">
     <a href="disabling-smtp-server-not-setup-error-topic.html#d0e20606" title="Probleme cu e-mailul">
      Probleme cu e-mailul
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-caller-id-not-shown-topic.html#d0e20725" title="Probleme la expedierea faxurilor">
      Probleme la expedierea faxurilor
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-scan-to-computer-topic.html#d0e21380" title="Probleme de scanare">
      Probleme de scanare
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-contacting-customer-support-topic.html#trb-contacting-customer-support_ro" title="Contactarea serviciului de asistenţă pentru clienţi">
      Contactarea serviciului de asistenţă pentru clienţi
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="recycle-dispose-chapter.html#recycle-dispose-chapter_ro" title="Reciclare şi eliminare">
     Reciclare şi eliminare
    </a>
   </p>
   <div id="divd0e22135">
    <p class="toc-2-style">
     <a href="recycling-lexmark-products-topic.html#recycling-lexmark-products_ro" title="Reciclarea produselor Lexmark">
      Reciclarea produselor Lexmark
     </a>
    </p>
    <p class="toc-2-style">
     <a href="recycling-lexmark-packaging-topic.html#recycling-lexmark-packaging_ro" title="Reciclarea ambalajelor Lexmark">
      Reciclarea ambalajelor Lexmark
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="laser_ug_notices.html#laser_ug_notices_ro" title="Note">
     Note
    </a>
   </p>
   <div id="divd0e22170">
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e22173" title="Ghidul informaţiilor despre produs">
      Ghidul informaţiilor despre produs
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e22190" title="Notă referitoare la ediţie">
      Notă referitoare la ediţie
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#trademarks_ro" title="Mărci comerciale">
      Mărci comerciale
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#licensing-notices_ro" title="Note de licenţă">
      Note de licenţă
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#noise-emission-levels_ro" title="Niveluri de poluare fonică">
      Niveluri de poluare fonică
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#weee-directive_ro" title="Directiva WEEE (Waste from Electrical and Electronic Equipment - Deşeuri din echipamente electrice şi electronice)">
      Directiva WEEE (Waste from Electrical and Electronic Equipment - Deşeuri din echipamente electrice şi electronice)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e22296" title="Baterie re&icirc;ncărcabilă litiu-ion">
      Baterie re&icirc;ncărcabilă litiu-ion
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#eu-battery-directive-2023-1542_ro" title="Regulamentul (UE) 2023/1542">
      Regulamentul (UE) 2023/1542
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e22334" title="Environmental labeling for packaging">
      Environmental labeling for packaging
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#product-disposal_ro" title="Dezafectarea produsului">
      Dezafectarea produsului
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#returning-lexmark-cartridges-for-reuse-or-recycling_ro" title="Returnarea cartuşelor Lexmark pentru reutilizare sau reciclare">
      Returnarea cartuşelor Lexmark pentru reutilizare sau reciclare
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#static-sensitivity-notice_ro" title="Notificare de sensibilitate statică">
      Notificare de sensibilitate statică
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#energy-star_ro" title="ENERGY STAR">
      ENERGY STAR
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#temperature-information_ro" title="Informaţii cu privire la temperatură">
      Informaţii cu privire la temperatură
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#laser-notice_ro" title="Notă cu privire la laser">
      Notă cu privire la laser
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#power-consumption_ro" title="Consumul de energie">
      Consumul de energie
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#regulatory-notices-for-telecommunication-terminal-equipment_ro" title="Notificări &icirc;n legătură cu reglementările privind echipamentele terminale de telecomunicaţii">
      Notificări &icirc;n legătură cu reglementările privind echipamentele terminale de telecomunicaţii
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e22593" title="Notificări &icirc;n legătură cu reglementările privind produsele care utilizează comunicaţiile fără fir">
      Notificări &icirc;n legătură cu reglementările privind produsele care utilizează comunicaţiile fără fir
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#modular-component-notice_ro" title="Notificare privind componentele modulare">
      Notificare privind componentele modulare
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#exposure-to-radio-frequency-radiation_ro" title="Expunerea la radiaţii de radio-frecvenţă">
      Expunerea la radiaţii de radio-frecvenţă
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e22618" title="Conformitate cu directivele Comunităţii Europene (CE)">
      Conformitate cu directivele Comunităţii Europene (CE)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#european-community-ec-directives-conformity-class-b_ro" title="Conformitate cu directivele Comunităţii Europene (CE)">
      Conformitate cu directivele Comunităţii Europene (CE)
     </a>
    </p>
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue